module.exports = __webpack_public_path__ + "static/media/2e16962e-d63b-4e8e-a35c-dc7ba5faf6f6.39d71e8a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274157/2e16962e-d63b-4e8e-a35c-dc7ba5faf6f6.eot
// module id = 556
// module chunks = 2